import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Switch from "@mui/material/Switch";
import { HexColorPicker, HexColorInput } from "react-colorful";
import { Flag } from "./type";

interface Props {
  open: boolean;
  isAddingNew: boolean;
  editedFlag: Flag | null;
  showValidation: boolean;
  onFieldChange: (field: keyof Flag, value: string) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
  onSave: () => void;
}

export default function FlagFormDrawer({
  open,
  isAddingNew,
  editedFlag,
  showValidation,
  onFieldChange,
  onStatusChange,
  onClose,
  onSave,
}: Props) {
  const nameInvalid = showValidation && !editedFlag?.name?.trim();

  return (
    <>
      <div className={`ctpl-overlay${open ? " open" : ""}`} onClick={onClose} />
      <div className={`ctpl-drawer${open ? " open" : ""}`}>
        <div className="ctpl-drawer-header">
          <h2>{isAddingNew ? "Add Flag" : `Edit — ${editedFlag?.name || ""}`}</h2>
          <button className="ctpl-icon-btn" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="ctpl-drawer-body">
          {/* Flag name */}
          <div className="ctpl-field-group">
            <label className="ctpl-field-label">
              Flag Name <span className="ctpl-required">*</span>
            </label>
            <input
              type="text"
              className={`ctpl-field-input${nameInvalid ? " error" : ""}`}
              placeholder="e.g. Mumbai Branch"
              value={editedFlag?.name || ""}
              onChange={(e) => onFieldChange("name", e.target.value)}
            />
            {nameInvalid && <div className="ctpl-field-error">Flag Name is required</div>}
          </div>

          {/* Category */}
          <div className="ctpl-field-group">
            <label className="ctpl-field-label">Category</label>
            <select
              className="ctpl-field-input"
              value={editedFlag?.category || ""}
              onChange={(e) => onFieldChange("category", e.target.value)}
            >
              <option value="Branch">Branch</option>
              <option value="Job Type">Job Type</option>
              <option value="Mode">Mode</option>
            </select>
          </div>

          {/* Color */}
          <div className="ctpl-field-group">
            <label className="ctpl-field-label">Hex Color</label>
            <div className="mf-picker-wrap">
              <HexColorPicker
                color={editedFlag?.hex_color_code || "#000000"}
                onChange={(newColor) => onFieldChange("hex_color_code", newColor)}
              />
              <div className="mf-picker-row">
                <span
                  className="mf-picker-swatch"
                  style={{ backgroundColor: editedFlag?.hex_color_code || "#000000" }}
                />
                <HexColorInput
                  color={editedFlag?.hex_color_code || "#000000"}
                  onChange={(newColor) => onFieldChange("hex_color_code", newColor)}
                  prefixed
                  className="ctpl-field-input mf-hex-input"
                />
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="ctpl-field-group">
            <label className="ctpl-field-label">Description</label>
            <input
              type="text"
              className="ctpl-field-input"
              placeholder="Short description"
              value={editedFlag?.description || ""}
              onChange={(e) => onFieldChange("description", e.target.value)}
            />
          </div>

          {/* Status */}
          {/* <div className="ctpl-toggle-row">
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 600 }}>Active</div>
              <div className="ctpl-hint">Deactivated flags can't be attached to new records.</div>
            </div>
            <Switch
              className="thinSwitch"
              checked={editedFlag?.status === "Active"}
              onChange={onStatusChange}
              color="primary"
            />
          </div> */}
        </div>

        <div className="ctpl-drawer-footer">
          <button className="ctpl-btn ctpl-btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button className="ctpl-btn ctpl-btn-primary" onClick={onSave}>
            {isAddingNew ? "Save Flag" : "Save changes"}
          </button>
        </div>
      </div>
    </>
  );
}